import { render, staticRenderFns } from "./DataStatisSummary.vue?vue&type=template&id=2f8ba8a4&scoped=true"
import script from "./DataStatisSummary.vue?vue&type=script&lang=js"
export * from "./DataStatisSummary.vue?vue&type=script&lang=js"
import style0 from "./DataStatisSummary.vue?vue&type=style&index=0&id=2f8ba8a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8ba8a4",
  null
  
)

export default component.exports